/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;max-width:500px}mat-input-container[_ngcontent-%COMP%]{width:85%}mat-input-container[_ngcontent-%COMP%]   mat-hint.hinterror[_ngcontent-%COMP%]{color:red}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/services/dialogs/updatecollegeID/updatecollegeID.dialogcomponent.css.shim.ngstyle.js.pre-build-optimizer.js